import { expose } from '@interlucent/global';
import { setLogLevel, clearLogLevel } from './globalThreshold';
/**
 * Expose logging DevTools helpers on the global `interlucent` namespace.
 *
 * Safe to call multiple times — simply overwrites with the same references.
 *
 * After calling:
 *   interlucent.setLogLevel('debug')
 *   interlucent.clearLogLevel()
 */
export function exposeDevTools() {
    expose('setLogLevel', setLogLevel);
    expose('clearLogLevel', clearLogLevel);
}
